import React from "react";

function HumanAITeams() {
  return (
    <div className="py-12 md:py-18">
      <div className="container mx-auto px-4 md:px-8 lg:px-16">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="mb-10 md:mb-12">
            <h2 className="RoobertLight text-3xl md:text-4xl lg:text-5xl font-bold text-dark-blue mb-6">
              Human + AI delivery teams
            </h2>
            <h3 className="RoobertMedium text-xl md:text-2xl font-bold text-dark-blue mb-6">
              AI doesn't replace people. It works with them.
            </h3>
            <p className="RoobertRegular text-lg text-dark-blue mb-8">
              Our delivery model is hybrid by default - blending the best of
              human expertise with the speed and scale of automation.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-8">
            {/* Each team includes */}
            <div>
              <h4 className="RoobertMedium text-lg md:text-xl font-bold text-dark-blue mb-4">
                Each team includes:
              </h4>
              <ul className="space-y-3">
                {[
                  "Senior consultants and solution architects",
                  "ML and data engineers",
                  "Reusable domain-trained AI coworkers",
                  "A lean layer of analysts building capability",
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-green-400 mt-2 flex-shrink-0"></div>
                    <span className="RoobertRegular text-dark-blue">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* In practice */}
            <div>
              <h4 className="RoobertMedium text-lg md:text-xl font-bold text-dark-blue mb-4">
                In practice:
              </h4>
              <ul className="space-y-3">
                {[
                  "Agents configure campaigns, run regression tests, summarize documents, generate SQL",
                  "Humans design strategy, validate outputs, manage change, and steer the roadmap",
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-green-400 mt-2 flex-shrink-0"></div>
                    <span className="RoobertRegular text-dark-blue">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Conclusion */}
            <div className="space-y-4">
              <p className="RoobertRegular text-dark-blue">
                Each AI coworker has a defined scope, escalation path, audit
                trail, and fallback mechanism.
              </p>
              <p className="RoobertRegular text-dark-blue">
                This model delivers enterprise-grade control, transparency, and
                explainability - not just automation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HumanAITeams;
